import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { isValidEmail } from './email';

type CheckoutFormProps = {
  disabled: boolean;
  onSubmit: (email: string) => void;
};

export function CheckoutForm({ disabled, onSubmit }: CheckoutFormProps) {
  const [email, setEmail] = useState('');
  const [invalid, setInvalid] = useState(false);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!isValidEmail(email)) {
      setInvalid(true);
      return;
    }
    setInvalid(false);
    onSubmit(email);
  };

  return (
    <Form className="external-sales-checkout__form" onSubmit={handleSubmit} noValidate>
      <Form.Group controlId="externalSalesCheckoutEmail">
        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          value={email}
          isInvalid={invalid}
          placeholder="you@example.com"
          onChange={(event) => setEmail(event.target.value)}
        />
        <Form.Control.Feedback type="invalid">
          Please enter a valid email address.
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Text className="text-muted mb-4 d-block external-sales-checkout__consent">
        By continuing you agree to be contacted about this purchase.
      </Form.Text>
      <Button type="submit" variant="primary" size="lg" block disabled={disabled}>Pay</Button>
    </Form>
  );
}
